export default __webpack_public_path__ + "static/web-beyond-today-506097c59d682aa1e5aa7e21f0d4aba2.png";